"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable default-case */
var react_1 = tslib_1.__importDefault(require("react"));
var _message_1 = tslib_1.__importDefault(require("../_components/_message"));
var NormalLoading_1 = require("../Icons/NormalLoading");
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var PromptErrorFill_1 = require("../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../Icons/PromptInfoCircleFill");
var AnqToast = {
    success: function (text, duration, config) {
        var _a = config || {}, onClose = _a.onClose, key = _a.key;
        var tempConfig = genConfig('success', text, duration, onClose, key);
        return _message_1.default.success(tempConfig);
    },
    warn: function (text, duration, config) {
        var _a = config || {}, onClose = _a.onClose, key = _a.key;
        var tempConfig = genConfig('warn', text, duration, onClose, key);
        return _message_1.default.warn(tempConfig);
    },
    error: function (text, duration, config) {
        var _a = config || {}, onClose = _a.onClose, key = _a.key;
        var tempConfig = genConfig('error', text, duration, onClose, key);
        return _message_1.default.error(tempConfig);
    },
    info: function (text, duration, config) {
        var _a = config || {}, onClose = _a.onClose, key = _a.key;
        var tempConfig = genConfig('info', text, duration, onClose, key);
        return _message_1.default.info(tempConfig);
    },
    loading: function (text, duration, config) {
        var _a = config || {}, onClose = _a.onClose, key = _a.key;
        var tempConfig = genConfig('loading', text, duration, onClose, key);
        return _message_1.default.loading(tempConfig);
    },
};
var genConfig = function (type, text, duration, onClose, key) {
    var icon;
    switch (type) {
        case 'success':
            icon = react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { className: "toast-icon" });
            break;
        case 'error':
            icon = react_1.default.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, { className: "toast-icon" });
            break;
        case 'info':
            icon = react_1.default.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { className: "toast-icon" });
            break;
        case 'warn':
            icon = react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "toast-icon" });
            break;
        case 'loading':
            icon = react_1.default.createElement(NormalLoading_1.NormalLoading, { spin: true, className: "toast-icon" });
            break;
    }
    var config = {
        icon: icon,
        content: react_1.default.createElement("span", { className: "anq-toast-content" }, text),
        duration: duration,
        onClose: onClose,
        key: key,
    };
    return config;
};
exports.default = AnqToast;
//# sourceMappingURL=index.js.map